import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { panelStyle } from '../../utils/imagePanel';
import { OFFER_ID, scrollToOffer } from '../../utils/scrollToOffer';
export function Hero() {
  return <header className="relative overflow-hidden border-b border-white/5 bg-ink" data-id="element-26" data-mp="qmy8aeb5a45v">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-6 pb-16 pt-12 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-16 lg:pb-24 lg:pt-16" data-id="element-27" data-mp="lnvgvwo37wgd">
        <div data-id="element-28" data-mp="3u3x6rtfc1v3v">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold" data-id="element-29" data-mp="3u5hsctjo63pl">
            Curly Seducción
          </p>

          <h1 className="mt-6 font-display text-4xl leading-[1.05] text-cream sm:text-5xl lg:text-6xl" data-id="element-30" data-mp="7vxcu098gqr2">
            El método para que tu rizo se defina solo,
            <span className="italic text-gold-soft" data-id="element-31" data-mp="2vssfz57fbvk"> con lo que ya tienes en casa</span>
          </h1>

          <p className="mt-6 max-w-prose text-base leading-relaxed text-sand sm:text-lg" data-id="element-32" data-mp="1j9j1zlf3escl">
            Seis pasos para entender tu cabello, dejar de comprar al azar y llegar al tercer día
            con el rizo definido. Guía digital, lista en tu correo.
          </p>

          <div className="mt-9 flex flex-col items-start gap-3 sm:flex-row sm:items-center" data-id="element-33" data-mp="2g5puppbuvfzn">
            <a href={`#${OFFER_ID}`} onClick={scrollToOffer} className="inline-flex items-center gap-2 rounded-full bg-gold px-8 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-ink transition-colors duration-150 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40" data-id="element-34" data-mp="2l6x5lx9aovaj">
              Quiero el método
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-35" data-mp="21h38d3nt9nyx" />
            </a>
            <p className="text-xs text-sand" data-id="element-36" data-mp="268v3zsltqjvx">Acceso inmediato · Garantía de 10 días</p>
          </div>
        </div>

        <div className="h-80 w-full rounded-xl border border-gold/25 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)] sm:h-[26rem] lg:h-[32rem]" style={panelStyle(0)} role="img" aria-label="Mujer sonriendo con rizos definidos y voluminosos" data-id="element-37" data-mp="19pxg19ec0uk7" />
      </div>
    </header>;
}